import { useEffect, useState } from "react";
import { Card, Row, Col, Typography, Space, theme, Tooltip } from "antd";
import {
  CaretUpOutlined,
  CaretDownOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { AiFillTrophy } from "react-icons/ai";

const { Text, Title } = Typography;

const TopEntityCarouselCard = ({ title, data = [], duration = 3000, extra }) => {
  const [index, setIndex] = useState(0);
  const current = data[index] || {};
  const rank = index + 1;
  const isUp = current?.change >= 0;
  const { token } = theme.useToken();

  useEffect(() => {
    if (data.length > 1) {
      const interval = setInterval(
        () => setIndex((prev) => (prev + 1) % data.length),
        duration
      );
      return () => clearInterval(interval);
    }
  }, [data, duration]);

  return (
    <Card
      hoverable
      style={{ height: 180, body: { padding: "1rem", height: "100%" } }}
      title={<Text strong>{title}</Text>}
      extra={<Text>{extra}</Text>}
    >
      <Row style={{ height: "100%" }}>
        <Col span={8}>
          <div style={{ position: "relative", height: "100%" }}>
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Title level={1} style={{ margin: 0 }}>
                #{rank}
              </Title>
            </div>
          </div>
        </Col>
        <Col span={16}>
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              //   justifyContent: "space-between",
              paddingLeft: 10,
            }}
          >
            <Tooltip title={current?.designation || current?.condition}>
              <Text
                style={{
                  fontSize: 16,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {current?.designation || current?.condition || "—"}
              </Text>
            </Tooltip>

            <Space
              size="small"
              style={{
                fontSize: 14,
                color: token.colorTextSecondary,
              }}
            >
              {isUp ? (
                <CaretUpOutlined style={{ color: "#3f8600" }} />
              ) : (
                <CaretDownOutlined style={{ color: "#cf1322" }} />
              )}
              <Text
                style={{
                  fontSize: 26,
                  fontWeight: 600,
                  color: token.colorText,
                }}
              >
                {current?.totalClicks || 0}
              </Text>
              <EyeOutlined />
              <Text style={{ fontSize: 14 }}>views</Text>
            </Space>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default TopEntityCarouselCard;
